import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";
import Typography from "@material-ui/core/Typography";

class Ladders extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>

                <Grid item xs={12}>
                    <Table border={1}>
                        <TableBody>
                            <TableRow>
                                <TableCell width="33%">
                                    <Typography component={"div"} variant={"body2"}>
                                    Inventar-Nr. der Leiter
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="number_inventar"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.number_inventar}
                                        inputProps={{
                                            maxLength : 25
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Art der Leiter
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Grid container spacing={8}>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="type_of_ladder_1"
                                                label="Anlegeleiter"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.type_of_ladder_1}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="type_of_ladder_2"
                                                label="Mehrzweckleiter"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.type_of_ladder_2}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="type_of_ladder_3"
                                                label="Schiebeleiter"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.type_of_ladder_3}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="type_of_ladder_4"
                                                label="Podestleiter"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.type_of_ladder_4}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="type_of_ladder_5"
                                                label="Seilzugleiter"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.type_of_ladder_5}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="type_of_ladder_6"
                                                label="Steckleiter"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.type_of_ladder_6}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="type_of_ladder_7"
                                                label="Stehleiter"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.type_of_ladder_7}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="type_of_ladder_8"
                                                label="Tritt"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.type_of_ladder_8}
                                            />
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Werkstoff der Leiter
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Grid container spacing={8}>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="ladder_material_1"
                                                label="Aluminium"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.ladder_material_1}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="ladder_material_2"
                                                label="Stahl"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.ladder_material_2}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="ladder_material_3"
                                                label="Kunststoff"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.ladder_material_3}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="ladder_material_4"
                                                label="Edelstahl"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.ladder_material_4}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={4}>
                                            <FormCheck
                                                name="ladder_material_5"
                                                label="Holz"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.ladder_material_5}
                                            />
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Anzahl der Sproßen/Stufen
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="number"
                                        name="number_steps"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.number_steps}
                                        inputProps={{
                                            max : 50000
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    Leiterlänge/Leiter gekürzt auf
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="number"
                                        name="ladder_length"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.ladder_length}
                                        inputProps={{
                                            max : 250000
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Hersteller/Händler
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="producer"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.producer}
                                        inputProps={{
                                            maxLength : 25
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Artikel-/Typ-Nr.
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="article_number"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.article_number}
                                        inputProps={{
                                            maxLength : 25
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Datum der Anschaffung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormDate
                                        type="date"
                                        name="purchase_date"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.purchase_date}
                                        inputProps={{
                                            maxLength : 25
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Datum der Verschrottung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormDate
                                        type="date"
                                        name="scrapping_date"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.scrapping_date}
                                        inputProps={{
                                            maxLength : 25
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>

                <Grid item xs={12}>
                    <Table border={1}>
                        <TableHead>
                            <TableRow>
                                <TableCell width="40%">
                                    <Typography className={classes.textBold} component={"div"}
                                                variant={"body1"}>
                                        PRÜFKRITERIEN
                                    </Typography>
                                </TableCell>
                                <TableCell width="60%">
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        1. Holme
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                        Verformung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="spars_deformation"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung',
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung',
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend',
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.spars_deformation || ''}
                                        labelPlacement="bottom"
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Beschädigung (z.B. Risse)
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="spars_damage"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.spars_damage || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Scharfe Kanten, Splitter, Grat
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="spars_edge"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.spars_edge || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Abnutzung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="spars_abraison"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.spars_abraison || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Schutzbehandlung (bei Holz)
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="spars_treatment"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.spars_treatment || ''}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        2. Sprossen/Stufen/Plattform
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Verformung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="rung_deformation"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.rung_deformation || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Beschädigung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="rung_damage"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.rung_damage || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Scharfe Kanten, Splitter, Grat
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="rung_edge"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.rung_edge || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Verbindung zum Holm (z.B. Bördelung, Schraub-/Niet-Verbindung, Schweißnaht)
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="rung_connection"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.rung_connection || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Abnutzung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="rung_abraison"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.rung_abraison || ''}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        3. Spreizsicherung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Vollständigkeit/Befestigung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="spreading_completeness"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.spreading_completeness || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Funktionsfähigkeit
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="spreading_functionality"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.spreading_functionality || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Beschädigung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="spreading_damage"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.spreading_damage || ''}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        4. Beschlagteile
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Beschädigung/Korrosion
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="fittings_damage"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.fittings_damage || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Vollständigkeit/Befestigung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="fittings_completeness"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.fittings_completeness || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Funktionsfähigkeit
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="fittings_functionality"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.fittings_functionality || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Abnutzung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="fittings_abraison"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.fittings_abraison || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Schmierung (mech. Teile)
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="fittings_lubrication"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.fittings_lubrication || ''}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        5. Leiterfüße/Rollen
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Vollständigkeit/Befestigung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="rolls_completeness"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.rolls_completeness || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Abnutzung/Beschädigung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="rolls_damage"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.rolls_damage || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Funktionsfähigkeit
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="rolls_functionality"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.rolls_functionality || ''}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        6. Zubehör (z.B. Holmverlängerung, Fußverbreiterung, Wandabstützung)
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Vollständigkeit/Befestigung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="accessories_completeness"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.accessories_completeness || ''}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        7. Kennzeichnung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Betriebsanleitung (z.B. Piktogramm)
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="marking_instructions"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.marking_instructions || ''}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        8. Kontrollergebnis
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Leiter i.O. und verwendungsfähig
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="usable"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.usable || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Reparatur notwendig
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="repair"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.repair || ''}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body2"}>
                                    Leiter sofort verschrotten
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormRadio
                                        name="scrapping"
                                        options={[
                                            {
                                                value : 'okay',
                                                label : 'in Ordnung'
                                            },
                                            {
                                                value : 'not_okay',
                                                label : 'nicht in Ordnung'
                                            },
                                            {
                                                value : 'not_applicable',
                                                label : 'nicht zutreffend'
                                            }
                                        ]}
                                        onChange={handleChange}
                                        className={classes.formRadioSelection}
                                        classNameControl={classes.formButtonSelection}
                                        onBlur={handleBlur}
                                        value={values.scrapping || ''}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        Bemerkungen
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormField
                                        type="text"
                                        name="notations"
                                        multiline
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.notations}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        Datum
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormDate
                                        type="date"
                                        name="current_date"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.current_date}
                                    />
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    <Typography component={"div"} variant={"body1"}>
                                        Nächste Prüfung
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <FormDate
                                        type="date"
                                        name="next_review"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.next_review}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    textBold: {
        fontWeight: "500",
    },
    formRadioSelection: {
        flexDirection: "row",
    },
    formButtonSelection: {
        width: '30%',
    }
})

export default withStyles(styles) (Ladders)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/Ladders.js